module.exports = __webpack_public_path__ + "img/Europe.21426cc9.svg";